import config from '../../../config'
import { appendQueryParam } from './api-util'
import http from './http-util'
import { ChannelType } from '../models/channelType'

const { MERCHANT_PORTAL } = ChannelType
class PaymentMethodsPricingServiceApi {
  static getPaymentMethodCostAlternatives =
    ({ amount, paymentMethodId }) =>
    token => {
      let queryParams = ''
      queryParams = appendQueryParam(queryParams, 'amount', amount)
      return http.get(
        token,
        `${config.paymentMethodsPricingServiceUrl}/payment_method/${paymentMethodId}/channel_type/${MERCHANT_PORTAL}/price_signage_slider${queryParams}`,
        config.requestTimeoutPaymentMethods,
      )
    }

  static paymentPerMonth = ({ method, amount, months, storeId }, token) => {
    if (months) {
      let queryParams = ''
      queryParams = appendQueryParam(queryParams, 'amount', amount)
      queryParams = appendQueryParam(queryParams, 'repayment_months', months)
      return http.get(
        token,
        `${config.paymentMethodsPricingServiceUrl}/payment_method/${method}/channel_type/${MERCHANT_PORTAL}/price_signage${queryParams}`,
      )
    }
    return http.get(
      token,
      `${config.paymentMethodsPricingServiceUrl}/public/store/${storeId}/payment_methods/${method}/channel_type/${MERCHANT_PORTAL}/price_info?amount=${amount}`,
    )
  }
}

export default PaymentMethodsPricingServiceApi
